import { Grid, InputLabel, makeStyles, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CustomDatePicker from '../../../Components/CustomDatePicker'
import CustomInput from '../../../Components/CustomInput'
import CustomRadioButton from '../../../Components/CustomRadioButton'
import CustomSelect from '../../../Components/CustomSelect'
import CircularIndeterminate from '../../../Components/Loader'
import { showSnackbar } from '../../../Components/Snackbar/SnackbarActions'
import { GLOBAL_STEPPER_DATA } from '../../../Redux/actions'
import AdminPartnerClient from '../../../Service/Admin/partner_services'
import Header from './header'
import { mappedKeyJSON } from './MappedKeyJSON'
import StepperService from './StepperService'



const CommisionInfoAdmin = (props: any) => {
    const classes = useStyles();
    const data = {
        commission: "false",
        commission_rate: '',
        commission_currency: '',
        commission_notes: '',
        commission_period: '',
        commission_total: '',

    }
    const [userData, setUserData] = useState(data);
    const [loading, setLoading] = useState(false);
    const [currencyArr, setCurrencyArr] = useState([]);
    const global_data = useSelector((state: any) => state.stepperReducer);
    const dispatch = useDispatch();
    const global_data_common = useSelector((state: any) => state.commonReducer);
    console.log(global_data_common)
    console.log(global_data)

    const setInputState = (inputStateValue: any, inputId: any) => {
        setUserData({ ...userData, [inputId]: inputStateValue })
        console.log(inputStateValue)
    }
    const onChangeItem = (selectedItemValue: any) => {

        console.log(selectedItemValue)
        if (selectedItemValue.value != '') {
            if (selectedItemValue.id == "commission") {
                selectedItemValue.value = selectedItemValue.value == "Yes" ? "true" : "false"
            }
        }
        setUserData({ ...userData, [selectedItemValue.id]: selectedItemValue.value })
    };
    const onChangeDate = (selectedItemValue: any, id: any) => {
        setUserData({ ...userData, [id]: selectedItemValue })
    };
const firstElementRef=useRef(null);
    useEffect(() => {
        window.scrollTo(0,0);
        if(firstElementRef.current){
            //@ts-ignore
            firstElementRef.current.scrollIntoView();
          }
        StepperService.setCompDataArr(global_data_common.partnerDropdowns[mappedKeyJSON.Currencies], setCurrencyArr, currencyArr)
        if (global_data.Commision_admin_id != null) {
            setLoading(true)

            AdminPartnerClient.CommisionInfoAdmin(
                global_data.Commision_admin_id,
                { partner_profile_id: global_data.partner_profile },
                'GET'
            ).then((response: any) => {
                // setUserData(response.data.attributes)
                setUserData({
                    ...response.data.attributes,
                    commission: response.data.attributes.commission != null ? response.data.attributes.commission ? "true" : "false" : ""
                })
                setLoading(false)
            }).catch(() => { setLoading(false) });

        }
    }, [])

    const onSubmit = () => {
        console.log(userData)
        setLoading(true)
        if (global_data.Commision_admin_id == null) {
            AdminPartnerClient.CommisionInfoAdmin(
                '',
                { partner_profile_id: global_data.partner_profile, ...userData },
                'POST'
            ).then((response: any) => {
                dispatch({ type: GLOBAL_STEPPER_DATA, payload: { Commision_admin_id: response.data.id } });
                props.parentHandleNext(props.activeIndex + 1)
                dispatch(showSnackbar("Success", ["Information saved successfully"]))
                setLoading(false)
            }).catch(() => { setLoading(false) });
        } else {
            AdminPartnerClient.CommisionInfoAdmin(
                global_data.Commision_admin_id,
                { ...userData },
                "PUT"
            ).then(() => {
                props.parentHandleNext(props.activeIndex + 1)
                dispatch(showSnackbar("Success", ["Information updated successfully"]))
                setLoading(false)
            }).catch(() => { setLoading(false) });
        }

    }
    const onBack = () => {
        props.parentHandleNext(props.activeIndex - 1)
    }
    return (
        <div style={{ marginBottom: 40 }} ref={firstElementRef}>
            {/* <Header parentcall={onSubmit} /> */}
            <Grid container direction="row" alignItems="flex-start" style={{ padding: 30, marginBottom: 30 }}>
                <Grid item xs={10}>
                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 30 }}>
                        <Grid item xs={4}>
                            <Typography variant="h2">Commission</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <CustomSelect id="commission" labelText="Select commission" displayEmpty variant="outlined" itemArr={['Yes', 'No']} parentcall={onChangeItem}
                                defaultValue={userData.commission != "" ? userData.commission == "true" ? "Yes" : "No" : ""}
                            />
                        </Grid>
                    </Grid>

                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 30 }}>
                        <Grid item xs={4}>
                            <Typography variant="h2">Commission rate</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <CustomInput id="commission_rate" multiline={true} rows={4} variant="outlined" placeholder="Commission rate" parentcall={setInputState} value={userData.commission_rate} />
                        </Grid>
                    </Grid>

                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 30 }}>
                        <Grid item xs={4}>
                            <Typography variant="h2">Commission currency</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            {/* <CustomInput id="commission_currency" variant="outlined" placeholder="Commission Currency" parentcall={setInputState} value={userData.commission_currency} /> */}
                            <Autocomplete value={userData.commission_currency}
                                id="commission_currency"
                                options={currencyArr}
                                style={{ width: "100%" }}
                                className={classes.autoComplete}
                                onChange={(e: any) => {
                                    setUserData({ ...userData, ['commission_currency']: e.target.textContent })
                                }}
                                renderInput={(params: any) =>
                                    <TextField placeholder="Select commission currency"
                                        className="custom_autocomplete" {...params} style={{ borderWidth: 1 }}
                                    />
                                }
                            />
                        </Grid>
                    </Grid>

                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 30 }}>
                        <Grid item xs={4}>
                            <Typography variant="h2">Commission notes</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <CustomInput id="commission_notes" multiline={true} rows={4} variant="outlined" placeholder="Commission notes" parentcall={setInputState} value={userData.commission_notes} />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 30 }}>
                        <Grid item xs={4}>
                            <Typography variant="h2">Commission period</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <CustomInput id="commission_period" variant="outlined" placeholder="Commission period" parentcall={setInputState} value={userData.commission_period} />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 30 }}>
                        <Grid item xs={4}>
                            <Typography variant="h2">Commission total</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <CustomInput id="commission_total" variant="outlined" placeholder="Commission total" parentcall={setInputState} value={userData.commission_total} />
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
            <Header saveBtnTitle={'Save & Proceed'} isBack={true} parentcall={onSubmit} parentBackCall={onBack} />
            {loading && <CircularIndeterminate />}

        </div>
    )
}
export default CommisionInfoAdmin
const useStyles = makeStyles((theme) => ({
    labelText: {
        color: '#4D4F5C',
        fontSize: '16px',
        lineHeight: '22px',
        paddingRight: '10px'
    },
    autoComplete: {
        '& .MuiInputBase-input': {
            padding: "12px !important",
            fontSize: 16
        },
        '& .MuiInput-underline:before': {
            content: "' '",
            border: '0px !important',
            transition: 'none'
        },
        '& .MuiAutocomplete-popupIndicator': {
            marginRight: 5
        },
        '& .MuiAutocomplete-inputRoot': {
            border: '1px solid rgba(0, 0, 0, 0.23)',
            borderRadius: 5
        }
    }
}))
